import { defineComponent as _defineComponent } from 'vue'
import { computed, onBeforeMount, reactive, ref } from "vue";
import { AccommodationsService } from "@/services/AccommodationsService";
import router from "@/router";
import type { Accommodation } from "@/components/types";
import ProductsTableV2 from "@/components/Accommodations/product/ProductsTableV2.vue";
import ResourceErrorState from "@/components/layout/ResourceErrorState.vue";
import { useResourceState } from "@/services/useResourceState";
import { required, email } from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";
import { useToast } from "@/services/useToast";


export default /*#__PURE__*/_defineComponent({
  __name: 'AdminAccommodationDetailsView',
  setup(__props, { expose: __expose }) {
  __expose();

const accommodationService = new AccommodationsService();
const { showToast } = useToast();
const id: string = router.currentRoute.value.params.id as string;

const accommodationDetails = ref<Accommodation | null>(null);
const { loading, error, runLoad } = useResourceState();
const editing = ref(false);
const saving = ref(false);

const form = reactive({
  name: "",
  city: "",
  address: "",
  billingAddress: "",
  phoneNumber: "",
  email: "",
});

const rules = computed(() => ({
  name: { required },
  city: { required },
  address: { required },
  billingAddress: { required },
  phoneNumber: { required },
  email: { required, email },
}));

const v$ = useVuelidate(rules, form);

const errorMessages = (field: keyof typeof form) =>
  editing.value
    ? v$.value[field].$errors.map((error) => error.$message as string)
    : [];

const fillForm = () => {
  const details = accommodationDetails.value;
  if (!details) {
    return;
  }
  form.name = details.name ?? "";
  form.city = details.city ?? "";
  form.address = details.address ?? "";
  form.billingAddress = details.billingAddress ?? "";
  form.phoneNumber = details.phoneNumber ?? "";
  form.email = details.email ?? "";
};

const fetchData = () =>
  runLoad(async () => {
    accommodationDetails.value = await accommodationService.getAccommodation(
      id
    );
    fillForm();
  });

onBeforeMount(fetchData);

const startEditing = () => {
  fillForm();
  v$.value.$reset();
  editing.value = true;
};

const cancelEditing = () => {
  editing.value = false;
  fillForm();
  v$.value.$reset();
};

const saveAccommodation = async () => {
  const details = accommodationDetails.value;
  if (!details) {
    return;
  }
  v$.value.$touch();
  if (v$.value.$error) {
    return;
  }
  saving.value = true;
  try {
    const updated = await accommodationService.updateAccommodation(details.id, {
      ...form,
    });
    accommodationDetails.value = updated;
    fillForm();
    editing.value = false;
    v$.value.$reset();
    showToast("Szálláshely adatai mentve");
  } catch (e) {
    showToast("Szálláshely mentése sikertelen", "error");
  } finally {
    saving.value = false;
  }
};

const __returned__ = { accommodationService, showToast, id, accommodationDetails, loading, error, runLoad, editing, saving, form, rules, v$, errorMessages, fillForm, fetchData, startEditing, cancelEditing, saveAccommodation, computed, onBeforeMount, reactive, ref, get AccommodationsService() { return AccommodationsService }, get router() { return router }, ProductsTableV2, ResourceErrorState, get useResourceState() { return useResourceState }, get required() { return required }, get email() { return email }, get useVuelidate() { return useVuelidate }, get useToast() { return useToast } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})